export default __webpack_public_path__ + "static/media/c001-general2024-3.9dee8561.png";